import "../scss/styles.scss";




const image = 'https://media.complex.com/websites/seeyounextyear/bg_about.jpg';
const wrapper = document.getElementById('about-wrapper');
let introPlayed = false;
safetyFade(wrapper);
load(image).then(() => {
    introPlayed = true;
    fade(wrapper);
});



function load(src) {
    return new Promise(function(resolve, reject) {
        const image = new Image();
        image.addEventListener('load', resolve);
        image.addEventListener('error', reject);
        image.src = src;
    });
}

function fade(element) {
    var op = +element.style.opacity;  // initial opacity
    var timer = setInterval(function () {
        if (element.style.opacity >= 1){
            clearInterval(timer);
        }
        element.style.opacity = op;

        op += 0.006;
        element.style.opacity = op;
    }, 10);
}

// In case something goes wrong, fade in anyways
function safetyFade(element) {
    setTimeout(() => {
        if (!introPlayed) {
            fade(wrapper);
            animate();
        }
    }, 3000)
}

